module.exports = "/_next/static/images/Hero-bbacbb4796806b20c9eea4ab3615469d.webp";